
import React, { Component } from "react";
import { connect } from "react-redux";
import { sendAgrementPDPA } from "../../actions";
import IntlMessages from "../../utils/IntlMessages";
import {
  reduxForm,
  Field ,
} from "redux-form";
import renderInputCheckbox from '../../utils/CustomField/renderInputCheckbox'
import Policy_en from "../policy_en";
import Policy_th from "../policy_th";
import {
  FormGroup,
  Col,
} from 'reactstrap';

class PopupPDPA extends Component {

  
  constructor(props) {
    super(props);
  }

  render() { 
    const { locale } = this.props;
      return <div
            className="modal fade show"
            role="dialog"
            tabIndex="-1"
            style={{ display: "block" }}
          >
            <div
              className="modal-dialog modal-lg"
              role="document"
              style={{marginTop:"20%",lineBreak: "20"}}
            >
              <div className="modal-content">
                <div className="modal-body text-center">
                  <h4 style={{marginBottom:20}}>
                    โครงการ Eastspring Wealth Privilege ประจำปี 2565 ได้สิ้นสุดลงแล้ว เมื่อวันที่ 31 ธันวาคม 2565
                    {/* <IntlMessages id="commingSoon.header" /> */}
                  </h4>
                  <h5 style={{fontWeight:"normal"}}>
                  เตรียมพบกับสิทธิพิเศษจากโครงการประจำปี 2566 เร็วๆนี้
                    {/* <IntlMessages id="commingSoon.message" /> */}
                  </h5>
                </div>
              </div>
            </div>
          </div>
    }
  }

const mapStateToProps = ({ setting }) => {
  const {
    locale: { locale },
  } = setting; 
  return { locale  };
};

export default connect(mapStateToProps, {
})(PopupPDPA);
